import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CustomField } from '@assetaccountant/api/models/custom-field';
import { Feature } from '@assetaccountant/api/models/feature';
import { RegisterPermissionType } from '@assetaccountant/api/models/register-permission-type';
import { CustomFieldApi } from '@assetaccountant/api/services/custom-field.api';
import { SidePanelModel } from '@assetaccountant/assets/models/side-panel-model';
import { RegisterObjectId } from '@assetaccountant/core/models/register-object-id';
import { SidePanelComponent } from '../../side-panel/side-panel.component';
import { CustomFieldsEditSidePanelComponent } from '../custom-fields-edit-side-panel/custom-fields-edit-side-panel.component';

@Component({
  selector: 'app-custom-fields-view',
  templateUrl: './custom-fields-view.component.html',
  styleUrls: ['./custom-fields-view.component.scss'],
  standalone: false,
})
export class CustomFieldsViewComponent implements OnInit {
  @Input() id: RegisterObjectId;

  @Output() customFieldsUpdated = new EventEmitter<CustomField[]>();

  @ViewChild('sidePanel') sidePanel: SidePanelComponent;

  customFields: CustomField[];

  readonly PackageFeature = Feature;
  readonly RegisterPermission = RegisterPermissionType;

  get editTitle() {
    return this.customFields?.length ? 'Edit Custom Fields' : 'Add Custom Fields';
  }

  constructor(private customFieldApi: CustomFieldApi) {}

  ngOnInit(): void {
    if (!this.customFields) {
      this.loadCustomFields();
    }
  }

  addCustomFields() {
    if (this.customFields) {
      this.sidePanel.open(
        new SidePanelModel(CustomFieldsEditSidePanelComponent, this.editTitle, {
          width: 'md',
        }),
        sidePanel => {
          sidePanel.id = this.id;
          sidePanel.customFields = this.customFields ?? [];
        },
        sidePanel => [
          sidePanel.customFieldsUpdated.subscribe(customFields => {
            this.customFields = customFields;
            this.customFieldsUpdated.emit(customFields);
          }),
        ],
      );
    }
  }

  private loadCustomFields() {
    this.customFieldApi
      .get({ objectType: this.id.objectType, objectId: this.id.objectId })
      .subscribe(response => (this.customFields = response.result));
  }
}
